export const LIMIT_SETTING = {
  // 會員級距: free, advance, enterprise

  // 最多可以建立幾個團隊
  CREATE_GROUPS_COUNT_MAX_LIMIT: {
    free: 2,
    advance: 5,
    enterprise: 10,
  },
  // 一個團隊最多有幾個 admin
  ADMINS_OF_ONE_GROUP_MAX_LIMIT: {
    free: 2,
    advance: 5,
    enterprise: 10,
  },
  // 一個團隊最少有幾個 admin
  ADMINS_OF_ONE_GROUP_MIN_LIMIT: {
    free: 1,
    advance: 1,
    enterprise: 1,
  },
  // 一個團隊最多有幾個成員
  USERS_OF_ONE_GROUP_MAX_LIMIT: {
    free: 5,
    advance: 10,
    enterprise: 20,
  },
};
